import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

const styles = theme => ({
  card: {
    //margin:10,
  },

  cardHeader: {
    fontFamily: 'Nunito Sans SemiBold!important',
    fontSize: '16pt',
    backgroundColor: '#069999',
    color: '#fff',
    textAlign: 'left',
    height: '100%',
    width: '100%',
  },
  cardHeaderLink: {
    fontFamily: 'Nunito Sans Regular!important',
    fontSize: '12pt',
    backgroundColor: '#069999',
    color: '#fff!important',
    textAlign: 'left',
    '&:hover': {
      color: '#bbb!important',
    },
    fontWeight: '400!important',
  }
});

function Faq(props) {
  const { classes } = props;

  let faq
  let link
  switch (props.lang) {
    case "de":
      faq = 'Haufig gestellte Fragen'
      link= 'https://energie.wallonie.be/home/energies-vertes/solaire-photovoltaique/outils/questions-frequentes-sur-l-utilisation-de-la-carte-dynamique-de-wallonie.html'
      break;
    case "en":
      faq = 'Frequently Asked Questions'
      link= 'https://energie.wallonie.be/home/energies-vertes/solaire-photovoltaique/outils/questions-frequentes-sur-l-utilisation-de-la-carte-dynamique-de-wallonie.html'
      break;
    case "fr":
    default:
      faq = 'Foire aux questions'
      link= 'https://energie.wallonie.be/home/energies-vertes/solaire-photovoltaique/outils/questions-frequentes-sur-l-utilisation-de-la-carte-dynamique-de-wallonie.html'
  }

  return (
    <Card className={classes.card}>
      <a
        target="_blank"
        style={{fontWeight:400}}
        // Using target="_blank" without rel="noopener noreferrer" is a security risk: see https://mathiasbynens.github.io/rel-noopener  react/jsx-no-target-blank
        rel="noopener noreferrer"
        href={link}
      >
        <CardHeader
          className={classes.cardHeader}
          disableTypography
          title={faq}
        />
      </a>
    </Card>
  );
}

Faq.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Faq);